import { Box } from 'theme-ui'

function Counter({ total }) {
    return (
        <Box
            sx={{
                fontSize: 0,
                color: 'textInversed',
                display: 'flex',
                mr: 2,
                alignItems: 'center',
                justifyContent: 'center',
                bg: 'primary',
                width: 18,
                height: 18,
                borderRadius: 0,
            }}
        >
            {total}
        </Box>
    )
}

export default Counter
